export enum OrganizationType {
  epc = 'epc',
  integratedPlatform = 'integratedPlatform',
  materials = 'materials',
  /**
   * organization used to hold accounts awaiting assignment via dispatch
   */
  holding = 'holding',
}
export const OrganizationTypes: OrganizationType[] = Object.values(OrganizationType);
export const OrganizationTypeLabels: Record<OrganizationType, string> = {
  epc: 'EPC',
  integratedPlatform: 'Integrated Platform',
  materials: 'Materials',
  holding: 'Holding',
};
